export interface Address {
  address1: string
  address2: string
  city: string
  zipCode: string
  country: string
  region: string
}

export interface Biller {
  id: string
  firstName: string
  lastName: string
  email: string
  phone: string
  address: Address
}

export interface Recipient extends Biller {
  relationship: string
}

export const recipientConverter: firebase.firestore.FirestoreDataConverter<Recipient> = {
  toFirestore: recipient => {
    return {
      firstName: recipient.firstName,
      lastName: recipient.lastName,
      email: recipient.email,
      phone: recipient.phone,
      relationship: recipient.relationship,
      address: recipient.address
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    return {
      id: snapshot.id,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      relationship: data.relationship,
      address: data.address
    }
  }
}
